import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../../../common/simple/Checkbox';
import DoubleArrow from '../../../../images/newDesign/two_side_arrow.svg';
import ActionsCard from "../actionsCards/ActionsCard";
import { BankCard } from "../actionsCards/BankActionsCard";
import { CardsMatchWrapper } from '../BankAdjustmentsNew.styled';

const CardsMatch = ({ checked, onCheckboxChange, bllinkRecord, bankRecord, order }) => {
    const { t } = useTranslation();

    const [checkedState, setCheckedState] = useState(checked);

    const renderTransactions = (transaction, i) => {
        const date = transaction.chargeDate || transaction.PaymentDate;
        const amount = transaction.amount || transaction.Amount;
        const currency = transaction.currency || transaction.payment?.Currency;
        const paymentObject = transaction.expenseTypeKey || transaction.paymentDetails?.PaymentPlan?.ExtraInfo?.ApartmentNumber;
        const paymentMethod = transaction.methodText || transaction.Method || transaction.method;
        const paymentID = transaction.paymentID || transaction.expenseID;
        const paymentType = transaction.type ? transaction.type : transaction.isIncome ? t('expenses.income') : t('expenses.expense');
        const method = transaction.Method || transaction.method;
            
        return (
            <ActionsCard
                key={i}
                noFile
                date={date} 
                amount={amount} 
                currency={currency}
                paymentID={paymentID}
                paymentObject={paymentObject} 
                documentNumber={paymentID}
                paymentType={paymentType} 
                paymentMethod={paymentMethod}
                method={method}
            />
        )             
    };

    const onChange = () => {
        onCheckboxChange(order, !checkedState);
        setCheckedState(!checkedState);
    };

    const { date, confirmationId, description, paymentMethod } = bankRecord;
    const parsedType = bankRecord.credit ? t('expenses.income') : bankRecord.debit ? t('expenses.expense') : '';
    const creditOrDebitNum = bankRecord.credit ? bankRecord.credit : bankRecord.debit ? bankRecord.debit : '';

    return (
        <CardsMatchWrapper>
            <Checkbox
                checked={checkedState}
                onChange={onChange} 
                size={20}
                label={<div className='cards-match'>
                    <div className='few-records-wrapper'>
                        {bllinkRecord.map((transaction, i) => renderTransactions(transaction, i))}
                    </div>
                    <img src={DoubleArrow} alt="" className='double-arrow' />
                    <BankCard 
                        date={date} 
                        description={description}
                        confirmationId={confirmationId}
                        type={parsedType}
                        creditOrDebitNum={creditOrDebitNum}
                        paymentMethod={paymentMethod}
                    />             
                </div>}
            />
        </CardsMatchWrapper>
    );
};

export default CardsMatch;
